import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { Registration, UserRegistration } from '../model';
import { AUTH_CONFIG, AuthConfig } from '~auth/providers/auth.provider';

// need to define these
type USER_REGISTRATION_RESPONSE = {};
type USER_VERIFICATION_RESPONSE = {};
type FORGOT_PASSWORD_RESPONSE = {};
type RESET_PASSWORD_RESPONSE = {};

@Injectable()
export abstract class RegistrationService {
  constructor(protected http: HttpClient, @Inject(AUTH_CONFIG) protected authConfig: AuthConfig) { }
  abstract registerUser(user: UserRegistration): Observable<any>;
  abstract verifyUser(registration: Registration): Observable<any>;
  abstract forgotPassword(username: string): Observable<any>;
  abstract resetPassword(requestId: string, password: string): Observable<any>;
  abstract resendValidationCode(username: string): Observable<any>;
}



// WEBPACK FOOTER //
// ./src/app/auth/services/registration.service.ts